import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { MyAccount } from "./MyAccount";

export function Account() {
  const { customer } = ZuAuthStore();

  return <>{customer && <MyAccount customer={customer} />}</>;
}
